import dayjs from 'dayjs'
import type {baseComponentType} from 'src/biz/types'
export function jsonParse<T>(json: string): T {
  if (typeof json !== 'string') {
    console.error('不是JSON字符串')
    return [] as T
  }
  let origin = null
  try {
    origin = JSON.parse(json)
  } catch (error) {
    console.error('json解析错误!', error)
    origin = [] as T
  }
  return origin as T
}

export function transferSource<T>(dataSource: T | string): T {
  return typeof dataSource === 'string' ? jsonParse<T>(dataSource) : dataSource
}

const isType = <T>(t: T): string => Object.prototype.toString.call(t).slice(8, -1)

export const isEmpty = <T extends object>(data: T) => {
  if (!data) {
    return true
  }
  if (Array.isArray(data)) {
    return data.length === 0
  }
  if (isType(data) === 'Object') {
    return Object.keys(data).length === 0
  }
  return !!data
}

/**
 *
 * @param data Blob 类型 Excel 文件下载
 */
export const exportExcel = (data: any, name = 'download.xlsx') => {
  // const type = data.headers['content-type']
  const type = data.type
  // 结果数据类型处理
  const blob = new Blob([data], {type: type})
  const link = document.createElement('a')
  // 文件名
  link.download = name
  link.style.display = 'none'
  link.href = URL.createObjectURL(blob)
  document.body.appendChild(link)
  link.click() // 执行下载
  URL.revokeObjectURL(link.href) // 释放url
  document.body.removeChild(link) // 释放标签
}

export const formatFormJsonValue = (jsonData: baseComponentType[], formData: any) => {
  jsonData.map((item: baseComponentType) => {
    if (item.type === 'RangePicker' && formData[item.name] && item.firstKey && item.secondKey) {
      // 当字段为RangePicker，字段格式化返回
      formData = {
        ...formData,
        [item.firstKey]: dayjs(formData[item.name][0]).format(item.format),
        [item.secondKey]: dayjs(formData[item.name][1]).format(item.format),
      }
      Reflect.deleteProperty(formData, item.name)
    }
    if (item.type === 'Select' && item.mode === 'multiple' && formData[item.name]) {
      // 当字段为Select并且为多选，字段格式化返回
      formData = {
        ...formData,
        [item.name]: formData[item.name]?.join(',') || '',
      }
    }
  })
  return formData
}
